<div class="header-icon"
  (click)="onCloseClick()"
  a7s-id="side-panel-close-button">
  <mat-icon class="mat-icon-size-xs" svgIcon="ds-ic-close"></mat-icon>
</div>
  